module.exports = "\n<div class=\"printing-output\">\n\n  <h2 class=\"title\">HaMafteach <span class=\"letter\">{{ getHebrewLetter(letter) }}</span></h2>\n\n  <div [innerHtml]=\"output\"></div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/printing-output-page/printing-output-page.html
// module id = ../../../../../src/app/admin-area/containers/printing-output-page/printing-output-page.html
// module chunks = main